"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeEvents = exports.configure = exports.normalizeAuth = void 0;
const normalizeAuth = (explicitAuthMode, defaultAuthMode) => {
    if (!explicitAuthMode) {
        return defaultAuthMode;
    }
    if (explicitAuthMode === 'identityPool') {
        return 'iam';
    }
    return explicitAuthMode;
};
exports.normalizeAuth = normalizeAuth;
const configure = (ctx) => {
    const config = ctx.resourcesConfig;
    const eventsConfig = config.API?.Events;
    if (!eventsConfig) {
        throw new Error('Events API configuration is missing. Have you called Amplify.configure() with an `API.Events` configuration?');
    }
    const configAuthMode = (0, exports.normalizeAuth)(eventsConfig.defaultAuthMode, 'apiKey');
    const options = {
        appSyncGraphqlEndpoint: eventsConfig.endpoint,
        region: eventsConfig.region,
        authenticationType: configAuthMode,
        apiKey: eventsConfig.apiKey,
    };
    return options;
};
exports.configure = configure;
/**
 * Event API expects an array of JSON strings
 *
 * @param events - JSON-serializable value or an array of values
 * @returns array of JSON strings
 */
const serializeEvents = (events) => {
    if (Array.isArray(events)) {
        return events.map((ev, idx) => {
            const eventJson = JSON.stringify(ev);
            if (eventJson === undefined) {
                throw new Error(`Event must be a JSON-serializable value. Received ${String(ev)} at index ${idx}`);
            }
            return eventJson;
        });
    }
    const eventJson = JSON.stringify(events);
    if (eventJson === undefined) {
        throw new Error(`Event must be a JSON-serializable value. Received ${String(events)}`);
    }
    return [eventJson];
};
exports.serializeEvents = serializeEvents;
